/**
 * To use a FeatureFlag wrapper around a component, supply the flag name, the feature element to which it applies
 * and an optional fallback child if the flag is false. You can also supply a hash of flag name values and elements
 * if the flag is more than a simple boolean switch.
 *
 * children: the default element to render if the flag is not found, or is not in the flag map
 * featureElement: the element to render if the flag is truthy
 * featureFlag: the flag name to test against
 * map: a map of 'flagName': JSX.Element in the case where multiple possible renders based on the flag value are
 * possible
 */

import React, { useContext, useEffect, useState } from 'react';
import { FeatureFlagContext } from './context';

export const FeatureFlag = (props: any) => {
  const { children = <></>, featureElement, featureFlag, map } = props;

  const featureFlags = useContext<genericObject>(FeatureFlagContext);

  const [child, setChild] = useState<JSX.Element>();

  useEffect(() => {
    if (map != null) {
      setChild(
        map?.[featureFlags?.[featureFlag]]
          ? map[featureFlags[featureFlag]]
          : featureElement,
      );
    } else {
      setChild(
        String(featureFlags?.[featureFlag]).toLowerCase() === 'true'
          ? featureElement
          : children,
      );
    }
  }, [children, featureElement, featureFlag, featureFlags, map, setChild]);

  return <>{child}</>;
};
